import React from 'react';
import Label from 'components/form/Label/Label';
import { commafy } from 'helpers/number';
import { Row } from 'components/Containers/Row/Row';
import { Button } from 'components/form/Button';
import SectionContainer from 'components/Containers/SectionContainer/index';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import './StandardHomeLoanOfferRedesign.scss';
import { useConfig } from 'hook/config.hook';

const HomeLoanOfferDetails = props => {
  const { extraClass, offerMetadata } = props;
  const { config } = useConfig();
  return (
    <FlexContainer className={extraClass}>
      <Label
        type="mBody-2 subTitle1"
        color="fontBlue100"
        className={'bold margt10'}
      >
        {offerMetadata?.bestProduct?.lender?.name}
      </Label>
      <Label type="Body-1 mCaption" className={'flex-column margtb10'}>
        <span className={'flex-container'}>
          Estimated Mo. Payments:
          <span className="bold margl4">
            {' '}
            ${commafy(offerMetadata?.bestProduct?.monthlyPayment)}
          </span>
        </span>
        <span className={'flex-container'}>
          Loan Type:
          <span className="bold margl4">
            {' '}
            {offerMetadata?.bestProduct?.displayName}
          </span>
          | APR:{' '}
          <span className="bold margl4">
            {offerMetadata?.bestProduct?.apr}%
          </span>
        </span>
      </Label>
      <Label type="Body-2" className={'fontGray100 text-14 m-text-12'}>
        Apply Now on {offerMetadata?.bestProduct?.lender?.name}'s{' '}
        {config?.secureWebsiteDisclaimer}
      </Label>
    </FlexContainer>
  );
};

const StandardHomeLoanOfferRedesign = props => {
  const { offerMetadata } = props;
  const offerDetails = offerMetadata.bestProduct;
  return (
    <SectionContainer
      className={
        'flex-container homeLoanOffer grayShadow16 border-rad8px padB32'
      }
      padding={'padT40 m-padTB24'}
    >
      <Row className={'format100'}>
        <FlexContainer className={'flex-column'}>
          <FlexContainer className={'justify-between format100'}>
            <FlexContainer className={'m-flex-column'}>
              <img
                alt="credit card"
                src={offerDetails?.lender?.logoUrl}
                className="pointer imgCardSize align-self-center"
              />
              <HomeLoanOfferDetails
                extraClass={'flex-column m-hide marglr40 marglr20'}
                offerMetadata={offerMetadata}
              />
            </FlexContainer>
            <FlexContainer className={'flex-column align-self-center margt10'}>
              <Button
                mrphType="primary"
                onClick={props.clickApplyHandler}
                className="border-rad100px"
              >
                <Label
                  type="Subtitle-2"
                  color="primary_cta_text_light"
                  className={'text-16 m-text-14 marglr20 m-marglr10'}
                >
                  {'Apply for Offer'}
                </Label>
              </Button>
            </FlexContainer>
          </FlexContainer>
          <HomeLoanOfferDetails
            extraClass={'flex-column margt10 d-hide'}
            offerMetadata={offerMetadata}
          />
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};

export { StandardHomeLoanOfferRedesign };
